import { GlobalStore } from "../globalStore";

/** Keep in sync with backend/src/helpers/reportingProducts.ts */
export const REPORTING_PRODUCT_CODES = ["YIHQ-MOTORLIVE", "YIHQ-PSLIVE"];

const PRODUCT_COLORS = {
  "YIHQ-MOTORLIVE": "#ff5a44",
  "YIHQ-PSLIVE": "#2d6a4f",
};

const FALLBACK_COLORS = ["#ff5a44", "#2d6a4f", "#475762", "#98b8cf", "#5c7cfa"];

/**
 * @param {Array<{Product_code: string, Product_name?: string, Url_slug?: string}>} [apiProducts]
 *   Optional list from /dashboard-report/data-chart (preferred when present).
 */
export function getReportingProducts(apiProducts) {
  const fromApi = Array.isArray(apiProducts) && apiProducts.length > 0 ? apiProducts : null;
  const fromStore = GlobalStore.yiProducts || [];

  return REPORTING_PRODUCT_CODES.map((code, index) => {
    const found =
      (fromApi && fromApi.find((p) => p.Product_code === code)) ||
      fromStore.find((p) => p.Product_code === code);
    return {
      Product_code: code,
      Product_name: (found && found.Product_name) || code,
      Url_slug: found && found.Url_slug,
      color: PRODUCT_COLORS[code] || FALLBACK_COLORS[index % FALLBACK_COLORS.length],
    };
  });
}

export function productDisplayName(productCode, apiProducts) {
  const match = getReportingProducts(apiProducts).find((p) => p.Product_code === productCode);
  return (match && match.Product_name) || productCode;
}

export function quotesPathForProduct(product) {
  if (product && product.Url_slug) {
    return `/${product.Url_slug}/quotes`;
  }
  return "/";
}
